const People = () => import("Core/people/views/People");
const PeopleForm = () => import("Core/people/views/PeopleForm");
const PeopleProfile = () => import("Core/people/views/Profile");

export default {
    children: [
        {
            path: "people",
            name: "people",
            component: People,
            meta: {
                requiresAuth: true,
                title: "lang.people",
                restrict_by_login_type: ["employee", "customer"],
                restrict_by_permission: ["people.read"],
            },
        },
        {
            path: "person/:id?/:tab?",
            name: "person",
            component: PeopleProfile,
            meta: {
                requiresAuth: true,
                title: "lang.people",
                restrict_by_login_type: ["employee", "customer"],
                restrict_by_permission: ["people.read"],
            },
        },
    ],
};
